<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400px" @keydown.esc.stop="close">
            <v-card>
                <v-card-title class="text-h5 bg-grey-lighten-2">
                    <span class="text-h5">Optional Fields</span>
                </v-card-title>
                <v-card-text class="mt-5">
                    <v-alert density="compact" type="error" v-if="errorMessage">
                        {{ errorMessage }}
                    </v-alert>
                    <v-form class="" v-model="isFormValid" ref="form">
                        <v-date-input
                            v-model="dateRequired"
                            label="I'd like to process by (leave blank if no rush)"
                            autofocus
                        />

                        <!-- Location select box -->
                        <v-autocomplete
                            v-model="location"
                            :items="locationArray"
                            item-value="id"
                            item-title="id"
                            label="Select a location"
                            prepend-icon="map-marker"
                            return-object
                        ></v-autocomplete>

                        <!-- Note field -->
                        <v-textarea v-model="note" label="Enter a note here"> </v-textarea>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn
                        class="mr-3"
                        @click="proceed(true)"
                        color="secondary"
                        :disabled="!isFormValid || isSaving || isTubeSeries"
                        :loading="isSaving && isDraft"
                        variant="text"
                    >
                        Save as Draft
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" size="small" variant="text" @click="close">Cancel</v-btn>
                    <v-btn
                        class="mr-3"
                        @click="proceed(false)"
                        color="primary"
                        :disabled="!isFormValid || isSaving"
                        :loading="isSaving && !isDraft"
                    >
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { defineComponent } from "vue";

import moment from "moment";
import { EventBus } from "@/lib/event-bus";
import { fetchIncubators } from "@/services/benchling/benchlingAPI";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "CreateDialog",

    props: {
        modelValue: {
            default: false,
            required: true,
            type: Boolean,
        },
        errorMessage: {
            type: String,
        },
    },

    data() {
        return {
            datePicker: false,
            today: moment().format("YYYY-MM-DD"),
            locationArray: [],
            // Spinners
            isDraft: false,
            // Form validation
            isFormValid: false,
        };
    },

    computed: {
        ...mapGetters("plateCreate", ["collectionDate", "isSaving", "isTubeSeries", "request"]),
        dialog: function () {
            return this.modelValue;
        },
        displayCollectionDate: function () {
            return this.$options.filters.formatDate(this.date);
        },
        location: {
            get() {
                return this.request.location;
            },
            set(value) {
                this.updateRequest({
                    ...this.request,
                    location: value,
                });
            },
        },
        note: {
            get() {
                return this.request.note;
            },
            set(value) {
                this.updateRequest({
                    ...this.request,
                    note: value,
                });
            },
        },
        dateRequired: {
            get() {
                if (this.request.dateRequired) {
                    return this.request.dateRequired;
                    // return moment(this.request.dateRequired).format("YYYY-MM-DD");
                } else {
                    return undefined;
                }
            },
            set(value) {
                this.updateRequest({
                    ...this.request,
                    dateRequired: value,
                });
            },
        },
    },

    created() {
        this.init();
    },

    methods: {
        ...mapActions("plateCreate", ["updateRequest", "setCollectionData"]),
        async init() {
            try {
                // Get Locations
                this.locationArray = await fetchIncubators();
            } catch (err) {
                console.error(err);
                EventBus.$emit(
                    "message",
                    "Error loading dialog data. Please refresh your browser."
                );
            }
        },
        // Submit form (proceed)
        proceed(draft) {
            this.isDraft = draft;
            // Emit selections to parent
            this.$emit("submit", {
                dateRequired: this.dateRequired,
                location: this.location,
                note: this.note,
                status: draft ? "Draft" : "Open",
            });
        },
        close() {
            this.$emit("update:modelValue", false);
            this.$refs.form.reset();
        },
    },
});
</script>

<style scoped></style>
